"use client";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";

export default function Logos() {
	const t = useTranslations();
	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		const checkIfMobile = () => {
			setIsMobile(window.innerWidth < 800);
		};

		checkIfMobile();
		window.addEventListener("resize", checkIfMobile);

		return () => {
			window.removeEventListener("resize", checkIfMobile);
		};
	}, []);

	const logos = [
		{ id: 1, path: "/image/home/logos1/1.png", alt: "Logo 1" },
		{ id: 2, path: "/image/home/logos1/2.png", alt: "Logo 2" },
		{ id: 3, path: "/image/home/logos1/3.png", alt: "Logo 3" },
		{ id: 4, path: "/image/home/logos1/4.png", alt: "Logo 4" },
		{ id: 5, path: "/image/home/logos1/5.png", alt: "Logo 5" },
		{ id: 6, path: "/image/home/logos1/6.png", alt: "Logo 6" },
		{ id: 7, path: "/image/home/logos1/7.png", alt: "Logo 7" },
	];

	return (
		<div className=" ">
			<div className="container mx-auto px-4">
				{isMobile ? (
					<Marquee speed={40} gradient={false} className="overflow-hidden">
						<div className="flex items-center gap-6">
							{logos.map((logo) => (
								<div key={logo.id} className="mx-3 flex h-16 items-center">
									<Image
										src={logo.path}
										alt={logo.alt}
										width={160}
										height={60}
										className="h-auto max-h-14 w-auto object-contain"
									/>
								</div>
							))}
						</div>
					</Marquee>
				) : (
					<div className="grid grid-cols-3 items-center justify-items-center gap-4 md:grid-cols-4 lg:grid-cols-7">
						{logos.map((logo) => (
							<div key={logo.id} className="flex h-20 items-center justify-center">
								<Image
									src={logo.path}
									alt={logo.alt}
									width={200}
									height={100}
									className="h-auto max-h-16 w-auto object-contain"
								/>
							</div>
						))}
					</div>
				)}
			</div>
			<div className="mt-8 h-[1px] w-full bg-black"></div>
		</div>
	);
}
